import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const User = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="User" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M12 1C15.866 1 19 4.13401 19 8C19 10.2644 17.9236 12.2762 16.2559 13.5557C17.2404 13.8442 18.1497 14.2526 18.9443 14.8027C20.8538 16.1247 22 18.1901 22 21V22C22 22.5523 21.5523 23 21 23C20.4477 23 20 22.5523 20 22V21C20 18.8099 19.1462 17.3753 17.8057 16.4473C16.4113 15.4819 14.3904 15 12 15C9.61221 15 7.59064 15.4879 6.19531 16.457C4.85234 17.3898 4 18.8262 4 21V22C4 22.5523 3.55228 23 3 23C2.44772 23 2 22.5523 2 22V21C2 18.2032 3.14766 16.139 5.05469 14.8145C5.85042 14.2618 6.76135 13.8504 7.74805 13.5596C6.07783 12.2803 5 10.2664 5 8C5 4.13401 8.13401 1 12 1ZM12 3C9.23858 3 7 5.23858 7 8C7 10.7614 9.23858 13 12 13C14.7614 13 17 10.7614 17 8C17 5.23858 14.7614 3 12 3Z" fill="#000" />
  </StyledIcon>
));

User.displayName = 'User';

export { User };
